import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type { ViewComponent } from "@frui.ts/views";
import type TerminateExemptionViewModel from "viewModels/callCenter/search/exemptions/terminateExemption/terminateExemptionViewModel";
import { formatDateTime } from "utils/localizations";
import { emptyValue } from "utils/emptyValue";

const TerminatePreviewSectionView: ViewComponent<TerminateExemptionViewModel> = observer(({ vm }) => {
  return (
    <>
      <div className="bg-light mb-4 px-4 pt-4 rounded">
        <Form.Row>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("countryId")}</Form.Label>
            <div>{vm.translateCountryId(vm.exemptionResponse.vehicle?.countryId)}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("licensePlate")}</Form.Label>
            <div>{vm.exemptionResponse.vehicle?.licensePlate}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("validSince")}</Form.Label>
            <div className="text-nowrap">
              {vm.exemptionResponse.validSince ? formatDateTime(vm.exemptionResponse.validSince) : emptyValue}
            </div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("validUntil")}</Form.Label>
            <div className="text-nowrap">{vm.item.validUntilDate ? formatDateTime(vm.item.validUntilDate) : emptyValue}</div>
          </Form.Group>
          <Form.Group as={Col} sm={12} xs={12}>
            <Form.Label>{vm.translate("exemptionReasonId")}</Form.Label>
            <div>{vm.getExemptionReasonDescription(vm.exemptionResponse.exemptionReasonId) ?? emptyValue}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("creationRecordId")}</Form.Label>
            <div className="text-break">{vm.exemptionResponse.creationRecordId ?? emptyValue}</div>
          </Form.Group>
          <Form.Group as={Col} sm={6} xs={6}>
            <Form.Label>{vm.translate("cancellationRecordId")}</Form.Label>
            <div className="text-break">{vm.item.cancellationRecordId ?? emptyValue}</div>
          </Form.Group>
          <Form.Group as={Col} sm={12} xs={12}>
            <Form.Label>{vm.translate("officialRecordId")}</Form.Label>
            <div className="text-break">{vm.exemptionResponse.officialRecordId ?? emptyValue}</div>
          </Form.Group>
          <Form.Group as={Col} sm={12} xs={12}>
            <Form.Label>{vm.translate("cancellationReason")}</Form.Label>
            <div className="text-break">{vm.item.cancellationReason ?? emptyValue}</div>
          </Form.Group>
        </Form.Row>
      </div>
      <Form.Row className="d-flex justify-content-center align-items-center pt-4 pb-6">
        <strong className="d-flex justify-content-center align-items-center">{vm.translate("confirmationTerminate")}</strong>
      </Form.Row>
    </>
  );
});

export default TerminatePreviewSectionView;
